//import { ticketItemDataResponse, customItemDataResponse, ticketItemRequestType, customItemRequestType } from "@zeus/shared";
import {
  CartDatatype,
  NuggetEventType,
  PaymentInfo,
  PaymentInfoInterface,
  PrepareCartItemDataType,
} from '../cart/cart.types';
import { CateringOrderStatus, CateringOrderStatusV2 } from '../catering/cateringOrder.types';
import { DiscountResponseType } from '../discount/discount.types';
import { UserRestaurantsType } from '../employee/userRestaurants.types';
import { categoryDataResponse } from '../menu/category.types';
import { itemDataResponse } from '../menu/item.types';
import { CartModifierOption, Category } from '../menu/menu.types';
import { modifierData } from '../menu/modifier.types';
import { GetTicketDetailsPaymentData, PaymentType } from '../payment/payment.types';
import { createServiceChargeResponse } from '../payment/serviceCharge.types';
import { TicketQueueJobs } from '../queue/queue.types';
import { RestaurantResponseType } from '../restaurant/restaurant.types';
import { IStation } from '../restaurant/stations.types';
import { TableCreateType } from '../table/table.type';
import { TaxResponseType } from '../tax/tax.types';
import { customItemDataResponse, customItemRequestType } from './customItem.types';
import {
  allTicketItemDataResponse,
  GetTicketDetailsTicketItemData,
  ticketItemDataResponse,
  ticketItemRequestType,
} from './ticketItem.types';

export interface IDiscountDeleteEvent {
  ticketId?: number;
  ticketItemDiscountIds?: number[];
  ticketDiscountInstances?: any[];
  updatedTicketItems: any[];
  itemDiscountData: {
    ticketItemIndex: number;
    discounts: { id: number; value: number }[];
  }[];
  businessId: number;
}

interface BaseResponseType {
  success: boolean;
  message: string;
  error: string | null;
  data: any;
}

interface BaseResponseType {
  success: boolean;
  message: string;
  error: string | null;
  data: any;
}

export enum OrderType {
  All = 'all',
  DineIn = 'dine-in',
  Takeaway = 'take-away',
  Delivery = 'delivery',
  ThirdParty = 'third-party',
  CateringOrder = 'catering-order',
  GiftCardTicket = 'gift-card-ticket',
}

export enum GiftCardType {
  GiftCard = 'gift-card',
}

export type ExtendedOrderType = OrderType | GiftCardType;

export enum cartStatus {
  Confirmed = 'confirmed',
  Unconfirmed = 'unconfirmed',
}

export const OrderTypeDisplay: Record<OrderType, string> = {
  [OrderType.All]: 'All',
  [OrderType.DineIn]: 'Dine In',
  [OrderType.Takeaway]: 'Take Out',
  [OrderType.Delivery]: 'Delivery',
  [OrderType.ThirdParty]: '3rd Party',
  [OrderType.CateringOrder]: 'Catering',
  [OrderType.GiftCardTicket]: 'Gift Card Ticket',
};

export enum OrderSource {
  Website = 'website',
  CallIn = 'call-in',
  Kiosk = 'kiosk',
  POS = 'pos',
  QR = 'qr',
  Doordash = 'doordash',
  UberEats = 'uber-eats',
  MPOS = 'mpos',
  Nugget = 'nugget',
  GrubHub = 'grub-hub',
}
export const OrderTypeUIMapper: Record<OrderSource, string> = {
  [OrderSource.Website]: 'Website',
  [OrderSource.CallIn]: 'Call-In',
  [OrderSource.Kiosk]: 'KIOSK',
  [OrderSource.POS]: 'POS',
  [OrderSource.QR]: 'QR',
  [OrderSource.Doordash]: 'Doordash',
  [OrderSource.UberEats]: 'Uber-Eats',
  [OrderSource.MPOS]: 'MPOS',
  [OrderSource.Nugget]: 'Nugget',
  [OrderSource.GrubHub]: 'Grubhub',
};

export enum StatusType {
  Pending = 'pending',
  OnHold = 'on-hold',
  Send = 'send',
  Void = 'void',
  FulFilled = 'fulfilled',
  UnFulFilled = 'unfulfilled',
  PartiallyFulFilled = 'partially-fulfilled',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
  Moved = 'moved',
}

export enum KDCOrderStatus {
  preparing = 'preparing',
  prepared = 'prepared',
  voidOrder = 'void-order',
}

export enum MQTTMSGTYPE {
  createTicketId = 'create-ticket-id',
  ticketStatus = 'ticket-status',
  voidOrder = 'void-order',
  voidTicket = 'void-ticket',
  callServer = 'call-server',
  kdsPrint = 'kds-print',
  stickyPrint = 'sticky-print',
  tableStatusUpdate = 'table_status_update',
  tableStatusUpdateForNugget = 'table_status_update_nugget',
  refetchMenu = 'refetch-menu',
  closeOut = 'close-out',
  openUp = 'open-up',
  clockIn = 'clock-in',
  clockOut = 'clock-out',
  nugget = 'nugget',
  floorCreated = 'floor-created',
  floorDeleted = 'floor-deleted',
  ticketPaymentUpdate = 'ticket-payment-update',
  logOut = 'log-out',
  updateNumberOfServedGuests = 'update-number-of-served-guests',
  // Menu manager Mqtt
  createMenu = 'create-menu',
  updateMenu = 'update-menu',
  removeMenu = 'remove-menu',
  createCategory = 'create-category',
  updateCategory = 'update-category',
  removeCategory = 'remove-category',
  createItem = 'create-item',
  updateItem = 'update-item',
  removeItem = 'remove-item',
  createModifierGroup = 'create-modifier-group',
  updateModifierGroup = 'update-modifier-group',
  removeModifierGroup = 'remove-modifier-group',
  createModifier = 'create-modifier',
  updateModifier = 'update-modifier',
  removeModifier = 'remove-modifier',
  createModifierOption = 'create-modifier-option',
  updateModifierOption = 'update-modifier-option',
  removeModifierOption = 'remove-modifier-option',
  createTag = 'create-tag',
  removeTag = 'remove-tag',
  undoSplitMpos = 'undo-split-mpos',
  // payment module
  createCashDrawer = 'create-cash-drawer',
  updateCashDrawer = 'update-cash-drawer',
  removeCashDrawer = 'remove-cash-drawer',
  createTender = 'create-tender',
  updateTender = 'update-tender',
  removeTender = 'remove-tender',
  createDiscount = 'create-discount',
  updateDiscount = 'update-discount',
  removeDiscount = 'remove-discount',
  createSalesTax = 'create-sales-tax',
  updateSalesTax = 'update-sales-tax',
  removeSalesTax = 'remove-sales-tax',
  createServiceCharge = 'create-service-charge',
  updateServiceCharge = 'update-service-charge',
  removeServiceCharge = 'remove-service-charge',
  stockInStockOut = 'stock-in-stock-out',
  thirdPartyOrderReceived = 'third-party-order-received',
  thirdPartyOrderStatusUpdated = 'third-party-order-status-updated',
  kioskSetting = 'kiosk-settings',
  amsStatus = 'ams-device-status',
  qrNuggetTicketUpdate = 'qr-nugget-ticketupdate',
  syncOfflineDataWithMultiPos = 'sync-offline-data-with-multi-pos',
  removeEmptyTicket = 'remove-empty-ticket',
  orderEmptyTickets = 'order-empty-tickets',
  removeEmptyTicketByOrder = 'remove-empty-ticket-by-order',
  ticketUpdate = 'update-ticketId',
  deletePendingTicketItems = 'delete-pending-ticket-items',
  updatedTicketItemDiscount = 'update-ticket-item-discount',
  updatedTicketServiceCharges = 'update-ticket-service-charges',
  updateStatus = 'update-status',
  changeServer = 'change-server',
  splitTicketsOffline = 'split-tickets-offline',
  ticketDiscount = 'ticket-discount-update',
  changeTable = 'change-table',
  orderUpdate = 'order-update',
  updateTicketOnHold = 'update-ticket-on-hold',
  updateOrderType = 'update-order-type',
  updateTaxExemption = 'update-tax-exemption',
  updateTicketNote = 'update-note',
  addNewCustomerToTicket = 'add-new-customer-to-ticket',
  addExistingCustomerToTicket = 'add-existing-customer-to-ticket',
  updateNoOfGuests = 'update-no-of-guests',
  cfdUpdate = 'update-cfd',
  onlineReceipt = 'online-receipt',
  updatedHouseDrawerBalance = 'updated-house-drawer-balance',
  deviceHeartbeat = 'device-heartbeat',
  modifierOptionStockInStockOut = 'stock-in-stock-out-modifier-option',
  kdsUpdateStatus = 'kds-update-status',
  updateMoveTicketData = 'update-move-ticket-data',
  deleteOnHoldTicketItem = 'delete-onhold-ticket-items',
  movePayment = 'move-payment',
  settlementShiftUpdate = 'settlement-shift-update',
  businessHoursUpdate = 'business-hours-update',
  moveItemsOffline = 'move-item-offline',
}

export enum DynamoSqsEventStatus {
  SENT = 'SENT',
  ACKNOWLEDGED = 'ACKNOWLEDGED',
  FAILED = 'FAILED',
  RETRYING = 'RETRYING',
}

export enum MQTTMSGTYPELEVEL {
  SYSTEM = 'system',
  FLOW = 'flow',
}

export enum TicketPaymentStatus {
  Unpaid = 'unpaid',
  FullPaid = 'full-paid',
  PartialPaid = 'partial-paid',
  PartialRefund = 'partial-refund',
  FullRefund = 'full-refund',
  Unclosed = 'unclosed',
  Void = StatusType.Void,
  RefundInitiated = 'refund-initiated',
}

export enum FilterTicketPaymentStatus {
  Unpaid = 'unpaid',
  FullPaid = 'full-paid',
  PartialPaid = 'partial-paid',
  PartialRefund = 'partial-refund',
  FullRefund = 'full-refund',
  Unclosed = 'unclosed',
  Void = StatusType.Void,
}

export const TicketPaymentStatusDisplay: Record<string, string> = {
  [TicketPaymentStatus.Unpaid]: 'UnPaid',
  [TicketPaymentStatus.FullPaid]: 'Paid',
  [TicketPaymentStatus.PartialPaid]: 'Partial',
  [TicketPaymentStatus.PartialRefund]: 'Refunded',
  [TicketPaymentStatus.FullRefund]: 'Refunded',
  [TicketPaymentStatus.Unclosed]: 'Unclosed',
  [StatusType.Void]: 'Void',
  [TicketPaymentStatus.RefundInitiated]: 'Refund Initiated',
};

export const TicketPaymentStatusColorMap: Record<string, string> = {
  [TicketPaymentStatus.Unpaid]: '#FAE4E1',
  [TicketPaymentStatus.FullPaid]: '#E9F3EE',
  [TicketPaymentStatus.PartialPaid]: '#FFF4CC',
  [TicketPaymentStatus.PartialRefund]: '#B7BAC399',
  [TicketPaymentStatus.FullRefund]: '#B7BAC399',
  [TicketPaymentStatus.Unclosed]: '#B7BAC399',
  [TicketPaymentStatus.RefundInitiated]: '#FFF4CC',
  [StatusType.Void]: '#B7BAC399',
};

export enum JobType {
  OnHold = 'on-hold',
  OrderDelayed = 'orderDelayed',
  OrderDelayedAgain = 'orderDelayedAgain',
  AutoFire = 'autoFire',
}

export enum StatusQueryType {
  FulFilled = 'fulfilled',
  UnFulFilled = 'unfulfilled',
  PartiallyFulFilled = 'partially-fulfilled',
}

export enum ServeType {
  QuickServe = 'quickServe',
  FullServe = 'fullServe',
}

export enum OrderTracking {
  NotAssigned = 'not-assigned',
  Assigned = 'assigned',
  Dispatched = 'dispatched',
  EnRoute = 'en-route',
  Delivered = 'delivered',
  Cancelled = 'cancelled',
  None = 'none',
}

export enum AssignedTo {
  Me = 'me',
  Everyone = 'everyone',
}

export enum OrderStatus {
  Pending = 'pending',
  Active = 'active',
  Rejected = 'rejected',
  Scheduled = 'scheduled',
  Ready = 'ready',
  Completed = 'completed',
  Cancelled = 'cancelled',
}

export enum OrderStatusReq {
  Active = 'active',
  Rejected = 'rejected',
  Scheduled = 'scheduled',
  Ready = 'ready',
  Completed = 'completed',
  Unclosed = 'unclosed',
  Void = 'void',
  Cancelled = 'cancelled',
}

export interface DiscountTicketRequestType {
  id: number;
  value: number;
  discount?: any;
}
export interface TicketRequestType {
  tableNumber?: number;
  employeeId?: string;
  note?: string;
  status?: StatusType;
  enum: OrderType;
  serveType: ServeType;
  noOfGuests?: number;
  taxExemption?: boolean;
  discounts?: DiscountTicketRequestType[];
  serviceChargesIds?: string[];
  taxIds?: number[];
}

export interface TicketDataRequestType {
  restaurantId: number;
  tableNumber: number;
  employeeId: string;
  note: string;
  status: StatusType;
  enum: OrderType;
  serveType: ServeType;
  noOfGuests: number;
  taxExemption: boolean;
  ticketItems?: ticketItemRequestType[];
  customItems?: customItemRequestType[];
}

export interface EditTicketDataRequestType {
  restaurantId?: number;
  tableNumber?: number;
  employeeId?: string;
  note?: string;
  status?: StatusType;
  orderStatus?: OrderStatus;
  enum?: OrderType;
  serveType: ServeType;
  noOfGuests?: number;
  taxExemption?: boolean;
  ticketItems?: ticketItemRequestType[];
  customItems?: customItemRequestType[];
}

export interface TicketResponseType {
  success: boolean;
  data: TicketDataResponse[];
  message: string;
}

export interface CreateTicketResponseType {
  success: boolean;
  data: TicketDataResponse;
  message: string;
}

export interface CreateTicketDataResponseType {
  success: boolean;
  data: TicketDataResponse;
  message: string;
}

export interface UpdateTicketDataResponseType {
  success: boolean;
  data?: TicketDataResponse[] | TicketData[];
  message: string;
}

export interface CreateTicketIdResponseType {
  success: boolean;
  data: TicketIdDataResponse;
  message: string;
}

export interface TicketIdDataResponse {
  ticketNumber: number;
  restaurant: RestaurantResponseType;
  status: StatusType;
  enum?: OrderType;
  orderStatus?: OrderStatus;
  serveType: ServeType;
  noOfGuests: number;
  taxExemption: boolean;
  note: string;
  // employeeId: string;
  tableNumber: number;
  id: number;
  createdAt: Date;
  updatedAt: Date;
}
export interface ChangeTablePosResponse {
  id: number;
  ticketNumber: number;
  posRequestId: string;
  localTicketId: string;
  tableId: number;
  tableNo: string;
}
export interface TicketDataResponse {
  ticketNumber: number;
  restaurant: RestaurantResponseType;
  status: StatusType;
  enum?: OrderType;
  note: string;
  orderSource: string;
  ticketPaymentStatus: string;
  orderTracking: string;
  orderStatus: string;
  stationStatus?: string;
  // employeeId: string;
  tableNumber: number;
  serveType: ServeType;
  noOfGuests: number;
  taxExemption: boolean;
  id: number;
  orderId: number;
  createdAt: Date;
  updatedAt: Date;
  customItems?: customItemDataResponse[];
  ticketItems: ticketItemDataResponse[];
  payment?: PaymentType[];
  ticketDiscount?: DiscountResponseType[];
  serviceCharges?: createServiceChargeResponse[];
  tax?: TaxResponseType[];
  isOpenTab: boolean;
  openTabName: string;
  authorizedLimit: number;
  qrId?: number;
  order?: OrderData;
  table?: TableCreateType;
  employeeUserRestaurant?: UserRestaurantsType;
  paymentInfo?: PaymentInfo;
  isLinkedWithTable: boolean;
}

export interface TicketOrdersType {
  id: number;
  ticketNumber: number;
  note: null;
  status: string;
  cartId: number;
  actualPrice: number;
  discountedPrice: number;
  orderId: number;
  qrId?: number;
  orderType: string;
  orderStatus: string;
  orderSource: OrderSource;
  restaurantId: number;
  resImage: string;
  resBannerImage: string;
  resName: string;
  resAddress: string;
  resPhone: string;
  resLatitude: number;
  resLongitude: number;
  ticketPaymentStatus: string;
  createdAt: string;
  paymentInfo?: TicketPaymentInfo;
  ticketItems?: OrderTicketItemType[];
  isScheduledOrder?: boolean;
  is_gift_card_applied?: boolean;
}

export interface OrderTicketItemType {
  id: number;
  item: ItemType;
  quantity: number;
  price: number;
  metaData: IMetaData;
  splitId: string;
  sentToKds: boolean;
  ticketId: number;
  paymentDetails: any;
}
export interface ReorderItem {
  id: number;
  itemName: string;
  count: number;
  totalPrice: number;
  metaData: PrepareCartItemDataType;
}

export interface TicketOrdersItemType {
  id: number;
  itemName: string;
  actualPrice: number;
  discountedPrice: number;
  orderedQuantity: number;
  card_item: number;
  metaData: PrepareCartItemDataType;
}

export type AllTicketResponse = Omit<TicketDataResponse, 'ticketItems'> & {
  ticketItems: allTicketItemDataResponse[];
};

export type AllTicketResponseType = Omit<TicketResponseType, 'data'> & {
  data: StationData;
};

export interface TicketData {
  orderSource: OrderSource;
  id: number;
  ticketNumber: number;
  restaurant: RestaurantResponseType;
  tableNumber: number;
  // employeeId: string;
  note: string;
  status: StatusType;
  orderStatus?: OrderStatus;
  serveType: ServeType;
  orderType: string;
  noOfGuests: number;
  taxExemption: boolean;
  createdAt: Date;
  updatedAt: Date;
  ticketItems: TicketItemType[];
  customItems: customItemDataResponse[];
  payment?: PaymentType[];
  isNotificationSent?: boolean;
  employeeUserRestaurant?: UserRestaurantsType;
  paymentInfo?: PaymentInfoInterface;
}

export interface TicketQueueData {
  kdsOrderId: number;
  restaurantId: number;
  status?: TicketQueueJobs;
  new: boolean;
}

export interface TicketItemType {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  item?: ItemType;
  status?: string;
  modifiers?: modifierData[];
  category?: CategoryType;
  paymentInfo?: PaymentInfoInterface;
  quantity?: number;
}

export interface OnlineTicketItemType {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  item: IItemOnline;
  status?: string;
  quantity?: number;
  modifiers?: modifierData[];
  category?: CategoryType;
  price?: number;
  metaData: IMetaData;
  isLoyaltyApplied?: boolean;
  loyaltyAmountApplied?: number;
}

export interface IItemOnline {
  id: number;
  itemName: string;
  itemDescription?: string;
  itemPrice: number;
  itemPicture?: string;
  calories?: number;
  quantity?: number;
  preparationTime?: string;
  stockStatus?: string;
  stockValue?: number;
  sortOrder?: number;
  showOnMenu: boolean;
  showOnline: boolean;
  showPOS: boolean;
  showQR: boolean;
  showThirdParty?: boolean;
  posDisplayName?: string;
  kdsName?: string;
  isDiscount: boolean;
  discountPercentage: number;
  createdAt: Date;
  updatedAt: Date;
  totalLikes: number;
  totalReviews: number;
  startTime?: string;
  endTime?: string;
  kioskDisplayName?: string;
  kioskItemImage?: string;
  totalPrice?: number;
  taxLinkedWithParentSetting: boolean;
  calculatePricesWithTaxIncluded: boolean;
  takeoutException: boolean;
  orderQuantityLimit: boolean;
  minLimit: number;
  maxLimit: number;
  noMaxLimit: boolean;
  inheritModifiersFromCategory: boolean;
  inheritTagsFromCategory: boolean;
  onlineImage?: string;
  landscapeImage?: string;
  thirdPartyImage?: string;
  restaurantId?: number;
  status: string;
  createdBy?: string;
  updatedBy?: string;
  deletedBy?: string;
  deletedAt?: Date;
  isSpecialRequest: boolean;
}

export interface ILocation {
  id: number;

  name: string;
  address: string;
  latitude: number;
  longitude: number;

  // Optional fields
  building?: string;
  apartment?: string;
  street?: string;
  state?: string;
  city?: string;
  country?: string;
  zipCode?: number;

  // Timestamps
  createdAt: Date;
  updatedAt: Date;
}

export interface ItemType extends itemDataResponse {
  category: CategoryType;
}

type CategoryType = Omit<categoryDataResponse, 'menuId'>;

export interface SplitTicketDataRequestType {
  individualTickets?: EditTicketDataRequestType[];
}

export interface StationCategoryType {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  items?: itemDataResponse;
  customItems?: customItemDataResponse[];
  category?: object;
}

export interface StationData {
  [stationKey: string]: StationCategoryType[];
}

export interface GetTicketData {
  id: number;
  date: string;
  ticketPaymentStatus: TicketPaymentStatus;
  ticketStatus: StatusType.Void;

  createdAt: Date;
  orderSource: OrderSource;
  customer: {
    fullname: string;
  };
  ticketNumber?: number;
  totalBill?: number;
  tableNumber?: number;
  serverName?: string;
}

export interface TicketPaymentInfo {
  discount: number;
  tipAdded: boolean;
  totalTax: number;
  tipAmount: number;
  totalBill: number;
  paidAmount: number;
  actualPrice: number;
  platformFee: number;
  cardNetSales: number;
  cashNetSales: number;
  lastPaidAmount: number;
  discountedPrice: number;
  remainingAmount: number;
  lastConvenienceFee: number;
  totalServiceCharge: number;
  totalConvenienceFee: number;
  deliveryFeeInDollars: number;
  gratuityChargesAmount: number;
  nonRevenueinReportChargesAmount: number;
  giftCardAmount?: number;
}
export interface TicketDetailsData {
  id: number;
  restaurantId: number;
  source: OrderSource;
  type: OrderType;
  status: OrderStatus;
  tableNo: string;
  remainingAmount: number;
  createdAt: Date;
  totalTips: number;
  total: number;
  subTotal: number;
  noOfGuests: number;
  note: string;
  totalTax?: number;
  server: {
    fullName: string;
  };
  customer: { fullName?: string }; // You can replace this with an appropriate Customer interface if needed
  ticketStatus: StatusType;
  ticketPaymentStatus: TicketPaymentStatus;
  ticketItems: GetTicketDetailsTicketItemData[];
  payments?: GetTicketDetailsPaymentData[];
  paymentInfo?: TicketPaymentInfo;
}

export interface TicketDetailResponseType extends BaseResponseType {
  data: TicketDetailsData | null;
}
export interface voidReasonsResponseType {
  success: boolean;
  data: [voidReasonsResponse];
  message: string;
}

export interface voidReasonsResponse {
  id: number;
  reason: string;
}

export interface DeleteTicketResponseType {
  success: boolean;
  message: string;
}

export interface OrdersDataResponseType {
  success: boolean;
  data: TicketDataResponse[];
  totalCount?: number;
  message: string;
}

export interface ModifierJson {
  id: number;
  modifierName: string;
  isOptional: boolean;
  limit: number;
  price: number;
  createdAt: Date;
  updatedAt: Date;
  isGeneric: boolean;
  isSelected?: boolean;
  isCustomModifier?: boolean;
  multiSelect: boolean;
  nestedModifiers: ModifierJson[];
  modifierOption: CartModifierOption[];
  modifiers: ModifierJson[];
  modifierQuantity: number;
}

export interface ModifierGroupJson {
  id: number;
  groupName: string;
  description: string;
  maxSelector: number;
  minSelector: number;
  priority: number;
  multiSelect: boolean;
  isOptional: boolean;
  createdAt: Date;
  updatedAt: Date;
  isGeneric: boolean;
  subgroups: ModifierGroupJson[];
  modifiers: ModifierJson[];
  modifierName: string;
  isSelected: boolean;
  quantity?: number;
  modifierGroupId?: number;
}

interface Item {
  item_id: number | null;
  item_name: string | null;
}

interface OrderItemDetail {
  id: number;
  item: Item;
  status: string;
  fullfillmentTime: number;
  ticketFulfillmentTime: number;
  rush: boolean;
  recall: boolean;
  recallTime: number;
  station: number[];
  metaData: object;
  quantity: number;
}

interface CategoryInfo {
  categoryId: Category['id'];
  categoryName: Category['categoryName'];
  orderItemDetails: OrderItemDetail[];
}

interface CustomerInfo {
  name: string;
  phoneNumber: string;
  address: string;
  phoneCode: string;
}

interface EmployeeInfo {
  id: string;
  firstName: string;
}

interface DriverInfo {
  name: string;
  phoneNumber: string;
}

export interface KdsTicketDataResponse {
  // customerPhoneNumber: string;
  // customerAddress: string;
  // customerPhoneCode: number;
  employeeId: number;
  employeeFirstName: string;
  addDisposableItem: boolean;
  orderId: number;
  orderStatus: string;
  orderCreatedAt: string;
  orderUpdatedAt: string;
  kdsOrderId: number;
  kdsOrderStatus: string;
  kdsOrderCreatedAt: string;
  kdsOrderUpdatedAt: string;
  categoryInfo: CategoryInfo[];
  ticket: TicketData;
  allFulfilled?: boolean;
  allVoided?: boolean;
  recallTicket?: boolean;
  jobType?: TicketQueueJobs;
  driver?: DriverInfo;
  customer?: CustomerInfo;
  employee?: EmployeeInfo;
  utensils: boolean;
  sequenceTimestamp: number;
  stationStatus: string;
}

export interface AllKdsTicketResponseType {
  success: boolean;
  data: KdsTicketDataResponse[];
  message: string;
}

export interface AllKdsTicketResponsePrintType {
  success: boolean;
  data: KdsTicketDataResponse;
  message: string;
}

export interface AllKdxTicketResponseType {
  success: boolean;
  data: KdxTicketDataResponse[];
  message?: string;
}
type KdsStation = number[];

type MetaData = Record<string, any>;

// interface KdsTicketItem {
//   id: number;
//   status: string;
//   guest: string;
//   quantity: number;
//   price: number;
//   specialRequest: string;
//   createdAt: Date;
//   updatedAt: Date;
//   isSplited: boolean;
//   splitCount: number;
//   metaData: MetaData;
// }

interface KdsOrder {
  kdsOrderId: number;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  KdsOrderItem?: KdsOrderItem;
}

export interface KdsOrderItem {
  id: number;
  kdsOrderId: number;
  quantity: number;
  kdsTicketId: number;
  station: KdsStation;
  kdsFireTime: string;
  fullfillmentTime: number;
  status: string;
  createdAt: Date;
  updatedAt: Date;
  metaData: MetaData;
  ticketItem: TicketItemType;
  customItem: null | any;
  kdsOrder?: KdsOrder;
}

export interface KdsUpdateStatusResponseType {
  success: boolean;
  data: boolean;
  message: string;
}

export interface KdsSseData {
  kds_id: number;
  data:
    | KdsTicketDataResponse
    | OrderData
    | KdsSseEvent
    | ChangeTableData
    | ChangeServerData
    | CateringData
    | CateringDataV2;
}

export interface KdsSseEvent {
  eventName?: string;
}

export interface KdsSseStationData {
  kds_id: number;
  data: KdsTicketDataResponse;
}

export interface TicketTaxType {
  ticketId: number;
  taxId: number;
}

export interface UpdateTicketServiceChargeType {
  id: number;
  serviceChargeConfigurationId: number;
  serviceChargeConfiguration?: any;
  isUserInteracted?: boolean;
  isChecked?: boolean;
}
export interface ServiceChargeConfigurations {
  id: number;
  name: string;
  type: string;
  value: number;
}

export interface DiscountConfiguration {
  id: number;
  name: string;
  type: string;
  value: number;
}

export interface UpdateServiceChargesRequestType {
  serviceCharges: UpdateTicketServiceChargeType[];
}

export interface UpdateServiceChargesDataResponseType {
  id: number;
  serviceCharges: createServiceChargeResponse[];
}

export interface OrderResponseType {
  success: boolean;
  data: OrderData;
  message: string;
}

export interface OrderDataResponseType {
  success: boolean;
  data: OrderDataResponse;
  message: string;
}

export interface OrderData {
  id: number;
  status?: string;
  note: string;
  //tickets?: [TicketDataResponse]
}

export interface ChangeTableData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  tableNo: string;
}

export interface ChangeServerData {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  serverId: string;
  serverName: string;
}

export interface CateringDataV2 {
  sequenceTimestamp: number;
  orderNumber: string;
  serverName: string;
  orderStatus: CateringOrderStatusV2;
  items: {
    itemId: number; // assuming item.id is a string
    itemName: string;
    quantity: number;
    status: StatusType.FulFilled | StatusType.UnFulFilled;
  }[];
}
export interface CateringData {
  orderNumber: string; // assuming cateringOrder.id is a string
  serverName: string;
  orderStatus: CateringOrderStatus;
  items: {
    itemId: number; // assuming item.id is a string
    itemName: string;
    quantity: number;
    status: StatusType;
  }[];
}

export interface OrderDataResponse {
  id: number;
  status?: string;
  note?: string;
  noOfGuests?: number;
  tickets?: TicketDataResponse[];
  carts?: CartDatatype[];
  //tickets?: [TicketDataResponse]
}
export interface UnclosedCount {
  unclosedCount: number;
}

export interface removeEmptyTicketResponseType {
  success: boolean;
  message: string;
}

export interface PaginationType {
  totalPages?: number;
  nextPage: boolean;
}

export interface TicketDetailsResponseType extends BaseResponseType {
  data: GetTicketData[] | null;
  pagination?: PaginationType;
}

export interface TicketsDetailsRequestPramsType {
  searchText?: string;
  dateFrom?: Date;
  dateTill?: string;
  paymentStatus?: TicketPaymentStatus;
  source?: OrderSource;
  page: number;
  perPage: number;
}
export interface KdxTicketDataResponse {
  ticketId: number;
  note: string;
  fullfillmentTime: number;
  status: string;
  serveType: string;
  orderType: string;
  orderSource: string;
  recall: boolean;
  rush: boolean;
  reason: string | null;
  kdsFireTime: string | null;
  orderId: number;
  createdAt: string;
  updatedAt: string;
  categoryInfo: KdxCategoryInfo[];
  restaurant: {
    id: number;
    restaurantName: string;
  };
  employee: {
    id: string;
    firstName: string;
  };
  table: {
    id: number;
    tableNo: string;
  };
}

export interface KdxCategoryInfo {
  category_id: number;
  category_name: string;
  items?: KdxCategoryItem[];
}
export interface KdxCategoryItem {
  id: number;
  status: string;
  quantity: string;
  price: string;
  specialRequest: string | null;
  ticketId: number;
  itemName: string;

  selectedModifiers?: string[];
  metaData?: {
    modifierGroup?: KdxModifierGroup[];
  };
}
export interface KdxModifier {
  isSelected: boolean;
  modifierName: string;
}
export interface KdxModifierGroup {
  modifiers?: KdxModifier[];
  subgroups?: { modifiers: KdxModifier[] }[];
}

export interface SelectedModifier {
  price?: number | string;
  multiplierModifierQuantity: number;
  isPriceAvailable?: boolean;
  modifiersPrice?: string;
  totalModifierPrice?: string;
  modifierQuantity?: number;
  modifierNameWithComma?: string;
  modifierName?: string;
}
export interface IMetaData {
  isUpdated?: boolean;
  allergen: object[];
  modifierGroup: ModifierGroupJson[];
  selectedModifier?: SelectedModifier[];
  localItemId?: string;
}

export interface OrderDataType {
  id: number;
  status: StatusType;
  createdAt: Date;
  updatedAt: Date;
  tickets: TicketData[];
  kdsOrders: KdsOrder[];
  kdsOrderItems: KdsOrderItem[];
  note: string;
  noOfGuests: number;
  carts: CartDatatype[];
  charges?: { total: number; delivery_fee: number; delivery_tips: number };
}

export interface GetRefundInstanceResposeType extends BaseResponseType {
  data: PaymentType;
}

export interface ApplyLoyaltyRequestType {
  ticketId: number;
  loyaltyItemId: number;
  guest?: string;
  metadata?: IMetaData;
}
interface Printer {
  id: number;
  name: string;
  ipAddress: string;
  serialNumber: string;
  connectionStatus: boolean | null;
  createdAt: Date;
  updatedAt: Date;
  restaurantId: number;
}

interface ItemStation {
  quantity: string;
  name: string;
}

interface StationGroup {
  stationId: number;
  stationName: string;
  stationType: string;
  items: ItemStation[];
  printers: Printer[];
}

export type IStationGroupKDSPrint = StationGroup[];

export interface FilterItemType {
  key: string | number;
  display: string;
  status?: boolean;
}
export interface FilterDataType {
  title: string;
  data: FilterItemType[];
  multiSelect: boolean;
}
export type GenericFilterType = {
  [key: string]: boolean | { startDate: string; endDate: string };
};

export interface OrderFulfillmentEventForNugget {
  cartId: number;
  nuggetId: string;
  status: NuggetEventType;
  restaurantId: number;
}

interface OrderReadyAlertBase {
  type: 'email' | 'sms';
}

interface EmailOrderReadyAlert extends OrderReadyAlertBase {
  type: 'email';
  email: string;
  phoneNumber: string;
}

interface SmsOrderReadyAlert extends OrderReadyAlertBase {
  type: 'sms';
  phoneNumber: string;
}

export type OrderReadyAlertDetailsType = EmailOrderReadyAlert | SmsOrderReadyAlert;

export interface IKdsOrderEvent {
  kdsOder: KdsOrder;
  ticketItems: TicketItemType[];
  customItems: customItemDataResponse[];
  ticket: TicketData;
  businessId: number;
  defaultStations: IStation[];
  restaurantId: number;
  kdsOrderIds: number[];
}

export interface ItemDataForKdsStatusUpdate {
  id: number;
  ticketItems: {
    id: number;
    status: string;
    localItemId: string;
  }[];
  customItems: {
    id: number;
    status: string;
    localItemId: string;
  }[];
}

export interface CompleteTicketDataForKdsStatusUpdate extends ItemDataForKdsStatusUpdate {
  posRequestId: string;
  localTicketId: string;
  status: StatusType;
  orderStatus: OrderStatus;
}

export interface KdsPrintForPosRequestType {
  ticketId: number;
}

export interface KdsPrintForPosResponseType {
  success: boolean;
  data: KdsPrintForPosResponse;
  message: string;
}

export interface OrderPrintData {
  cognitoCreatedAt: Date;
  cognitoUpdatedAt: Date;
  cognitoCreatedBy: string;
  cognitoUpdatedBy: string;
  id: number;
  status: string;
  note: string;
  noOfGuests: number;
  orderoutReferenceId: string;
  orderPlacedAt: string;
  externalOrderId: string;
  addDisposableItem: boolean;
}

export interface KdsPrintForPosResponse {
  orderId: number;
  ticketNumber: number;
  orderNo: number;
  orderType: string;
  note: string;
  orderSource: string;
  customerName: string | null;
  restaurantId: number;
  businessId: number;
  phoneCode: string | null;
  phoneNumber: string;
  order: OrderPrintData;
  serverName?: string;
  noOfGuest: number;
  tableNo: number;
  time: Date;
  stations: StationGroup[];
  isUpdated: boolean;
  isBohKitchenReceiptsEnabled: boolean;
}

export interface KdsPrintForPosResponseType {
  success: boolean;
  data: KdsPrintForPosResponse;
  message: string;
}

export interface KdsPrintForPosResponseType {
  success: boolean;
  data: KdsPrintForPosResponse;
  message: string;
}

export interface OrderPrintData {
  cognitoCreatedAt: Date;
  cognitoUpdatedAt: Date;
  cognitoCreatedBy: string;
  cognitoUpdatedBy: string;
  id: number;
  status: string;
  note: string;
  noOfGuests: number;
  orderoutReferenceId: string;
  orderPlacedAt: string;
  externalOrderId: string;
  addDisposableItem: boolean;
}

export interface KdsPrintForPosResponse {
  orderId: number;
  ticketNumber: number;
  orderNo: number;
  orderType: string;
  note: string;
  orderSource: string;
  customerName: string | null;
  restaurantId: number;
  businessId: number;
  phoneCode: string | null;
  phoneNumber: string;
  order: OrderPrintData;
  serverName?: string;
  noOfGuest: number;
  tableNo: number;
  time: Date;
  stations: StationGroup[];
  isUpdated: boolean;
  isBohKitchenReceiptsEnabled: boolean;
}
